export enum InfoConversionStatus {
    READY,
    LOADING,
    SUCCESS,
    ERROR,
}

export interface SensitiveData {
    invitationUid: string
    jobSeekerId: number
    aggJobId: number
    emailRequestUid: string | null
    country: string | null
}

interface InfoConversionBaseState {
    error?: string
    status: InfoConversionStatus
}

export interface EncryptionState extends InfoConversionBaseState {
    data: string | null
}

export interface DecryptionState extends InfoConversionBaseState {
    data: SensitiveData | null
}
